import React from 'react';
import { Link as Anchor } from "react-router-dom";
import './BuscarCeroKm.css';

export default function BuscarCeroKm() {
    return (
        <section className='buscar-cero-km-section'>
            <div className='buscar-cero-km-container'>
                <div className='buscar-cero-km-text'>
                    {/* Título que crea urgencia y aventura */}
                    <h2 className='buscar-cero-km-title'>¡TU PROXIMA AVENTURA EMPIEZA HOY!</h2>
                    <br />
                    <h3 className='buscar-cero-km-title' style={{ fontSize: '20px' }}>ENCONTRA TU MOTO 0KM</h3>
                    <br />
                    <p className='buscar-cero-km-subtitle'>
                        No esperes mas para salir a rodar. Elegi entre nuestra seleccion de motos 0KM
                        con respaldo total y financiacion a tu medida para que empieces a disfrutar hoy mismo.
                    </p>
                    <div className='buscar-cero-km-features-grid'>
                        <div className='feature-item'>
                            <span className='feature-icon-container'>
                                <i className='fas fa-handshake'></i>
                            </span>
                            <p className='feature-text'>Financiación a tu medida</p>
                        </div>
                        <div className='feature-item'>
                            <span className='feature-icon-container'>
                                <i className='fas fa-shield-alt'></i>
                            </span>
                            <p className='feature-text'>Garantia oficial de fabrica</p>
                        </div>
                        <div className='feature-item'>
                            <span className='feature-icon-container'>
                                <i className='fas fa-motorcycle'></i>
                            </span>
                            <p className='feature-text'>Entrega inmediata. ¡Llevátela rodando el mismo dia!</p>
                        </div>
                    </div>
                    {/* Botón con una llamada a la acción clara y directa */}
                    <Anchor to="/stock/motos" className='buscar-cero-km-btn'>
                        QUIERO MI MOTO 0KM AHORA
                    </Anchor>
                </div>
            </div>
        </section>
    );
}